import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";

export default function ProviderTypeChip({ label }) {
  return (
    <div
      className="px-2 py-1"
      style={{ backgroundColor: HNSColors.secondary[900], borderRadius: "500px" }}
    >
      <Typography
        className="text-center text-[14px] font-normal"
        style={{ color: HNSColors.secondary[400] }}
      >
        {label}
      </Typography>
    </div>
  );
}
